import { useCallback } from "react";
import { useMessage } from "./useMessage";

const zonesToReuse: eXpress.collections.Dictionary<string, eXpress.core.ITransformableZone[]> =
	new eXpress.collections.Dictionary<string, eXpress.core.ITransformableZone[]>();

export function useReuseZonesForPages() {
	const getAndSetReuseZones = useCallback(
		(
			spread: eXpress.core.Spread | undefined,
		): eXpress.core.ITransformableZone[] | undefined => {
			if (!spread) return undefined;

			// Remember the starting SpreadZone user content (text and photos)
			const spreadKey = spread.index.toString();
			let zonesToReuseForSpread = zonesToReuse.get(spreadKey);

			if (!zonesToReuseForSpread) {
				zonesToReuseForSpread = spread.pageZones.flatMap(
					(pageZone) => pageZone?.getAllZones(),
				);

				zonesToReuse.add(spreadKey, zonesToReuseForSpread);
			}

			return zonesToReuseForSpread;
		},
		[],
	);

	useMessage((message) => {
		// If another command is executed, don't reuse zonesToReuse for applySpreadDesign Command
		if (
			!(message instanceof eXpress.core.SpreadReplacedMessage) &&
			eXpress.core.isCommandMessage(message)
		) {
			zonesToReuse.clear();
		}
	});

	return [getAndSetReuseZones] as const;
}
